export default "__VITE_ASSET__2jW$4siJ__"